import React, { useState, useRef } from 'react';

// ── Bond type options (dropdown order) ───────────────────────
const BOND_TYPES = [
  { value: '', label: '— Select bond type —', line: null },
  { value: '142d_40_60', label: 'Qualified residential rental project — 40-60 test (§142(d))', line: 'line_11f', showVolCap: true, showLine46: true, showPartV: true },
  { value: '142d_20_50', label: 'Qualified residential rental project — 20-50 test (§142(d))', line: 'line_11f', showVolCap: true, showLine46: true, showPartV: true },
  { value: '501c3_capex', label: 'Qualified 501(c)(3) nonhospital bond — 95% capital expenditures (§145(b))', line: 'line_18', showVolCap: false, showLine46: true, showPartV: true },
  { value: 'airport', label: 'Airport (§142(a)(1))', line: 'line_11a', showVolCap: true, showLine46: false, showPartV: true },
  { value: 'solid_waste', label: 'Solid waste disposal facilities (§142(a)(6))', line: 'line_11e', showVolCap: true, showLine46: false, showPartV: true },
  { value: '501c3_no_capex', label: 'Qualified 501(c)(3) nonhospital bond — no capital expenditure election', line: 'line_18', showVolCap: false, showLine46: true, showPartV: true },
  { value: 'hospital', label: 'Qualified hospital bond (§145(c))', line: 'line_17', showVolCap: false, showLine46: true, showPartV: true },
  { value: 'mortgage', label: 'Qualified mortgage bond (§143(a))', line: 'line_12a', showVolCap: true, showLine46: false, showPartV: false },
  { value: 'small_issue', label: 'Qualified small issue bond (§144(a))', line: 'line_14', showVolCap: true, showLine46: false, showPartV: true },
  { value: 'student_loan', label: 'Qualified student loan bond (§144(b))', line: 'line_15', showVolCap: true, showLine46: false, showPartV: false },
  { value: 'redevelopment', label: 'Qualified redevelopment bond (§144(c))', line: 'line_16', showVolCap: true, showLine46: false, showPartV: true },
  { value: 'docks', label: 'Docks and wharves (§142(a)(2))', line: 'line_11b', showVolCap: true, showLine46: false, showPartV: true },
  { value: 'water', label: 'Water furnishing facilities (§142(a)(4))', line: 'line_11c', showVolCap: true, showLine46: false, showPartV: true },
  { value: 'sewage', label: 'Sewage facilities (§142(a)(5))', line: 'line_11d', showVolCap: true, showLine46: false, showPartV: true },
  { value: 'mass_commuting', label: 'Mass commuting facilities (§142(a)(3))', line: 'line_11m', showVolCap: true, showLine46: false, showPartV: true },
  { value: 'education', label: 'Qualified public educational facility bonds (§142(a)(13))', line: 'line_11l', showVolCap: true, showLine46: false, showPartV: true },
  { value: 'broadband', label: 'Qualified broadband projects (§142(a)(16))', line: 'line_11k', showVolCap: true, showLine46: false, showPartV: true },
  { value: 'highway', label: 'Qualified highway or surface freight transfer facilities (§142(a)(15))', line: 'line_11n', showVolCap: true, showLine46: false, showPartV: true },
  { value: 'carbon', label: 'Carbon dioxide capture facilities (§142(a)(17))', line: 'line_11o', showVolCap: true, showLine46: false, showPartV: true },
  { value: 'heating_cooling', label: 'Local district heating or cooling (§142(a)(9))', line: 'line_11p', showVolCap: true, showLine46: false, showPartV: true },
  { value: 'output', label: 'Nongovernmental output property bond (§141(d))', line: 'line_19', showVolCap: true, showLine46: false, showPartV: true },
  { value: 'reissuance', label: 'Reissuance (§1.141-12)', line: 'line_20b', showVolCap: true, showLine46: false, showPartV: true },
  { value: 'other', label: 'Other', line: 'line_20c', showVolCap: true, showLine46: false, showPartV: true },
];

const NAICS_OPTIONS = [
  { value: '', label: '-- Select --' },
  { value: '236116', label: '236116 — New Multifamily Housing Construction (Low-Income Housing)' },
  { value: '488190', label: '488190 — Other Support Activities for Air Transportation (Airports)' },
  { value: '562212', label: '562212 — Solid Waste Landfill' },
  { value: '611310', label: '611310 — Colleges, Universities, and Professional Schools' },
  { value: '622110', label: '622110 — General Medical and Surgical Hospitals' },
  { value: 'other', label: 'Other (enter manually)' },
];

const PREPARER_DEFAULTS = {
  preparer_name: 'Stephen Larsen',
  preparer_ptin: 'P01066307',
  firm_name: 'Parker Poe Adams & Bernstein LLP',
  firm_address: '850 Morrison Drive Suite 400 Charleston SC 29403',
  firm_ein: '56-0928467',
  firm_phone: '843-727-6311',
};

// ── Styles (match Form8038G) ─────────────────────────────────
const cs = { flex:1, overflowY:'auto', padding:'24px', background:'var(--bg-primary)', color:'var(--text-primary)', fontFamily:'DM Sans,sans-serif' };
const card = { background:'var(--bg-secondary)', border:'1px solid var(--border-color)', borderRadius:'8px', padding:'20px', marginBottom:'20px' };
const sRow = { display:'flex', gap:'12px' };

const Hdr = ({t}) => (
  <div style={{background:'var(--ribbon-bg)',color:'var(--ribbon-text)',padding:'6px 14px',
    fontSize:'12px',fontWeight:'600',letterSpacing:'0.05em',textTransform:'uppercase',
    borderRadius:'4px',marginBottom:'12px',marginTop:'4px'}}>{t}</div>
);

const F = ({label,name,value,onChange,placeholder='',half=false,ro=false,warn=''}) => (
  <div style={{marginBottom:'12px',width:half?'calc(50% - 6px)':'100%'}}>
    <label style={{display:'block',fontSize:'11px',fontWeight:'600',
      color: warn ? '#7a5c00' : 'var(--text-secondary,#666)',marginBottom:'4px',
      textTransform:'uppercase',letterSpacing:'0.04em'}}>{label}{warn ? ' ⚠' : ''}</label>
    <input type="text" name={name} value={value||''} onChange={onChange}
      placeholder={placeholder} readOnly={ro}
      style={{width:'100%',padding:'7px 10px',
        border: warn ? '1px solid #f0c040' : '1px solid var(--border-color)',
        borderRadius:'4px',fontSize:'13px',boxSizing:'border-box',outline:'none',
        background: warn ? '#fffbea' : ro ? 'var(--bg-secondary)' : 'var(--bg-primary)',
        color:'var(--text-primary)'}} />
    {warn && <div style={{fontSize:'11px',color:'#7a5c00',marginTop:'3px',fontStyle:'italic'}}>{warn}</div>}
  </div>
);

const Chk = ({label,name,checked,onChange}) => (
  <label style={{display:'flex',alignItems:'flex-start',gap:'8px',marginBottom:'10px',
    cursor:'pointer',fontSize:'13px',color:'var(--text-primary)'}}>
    <input type="checkbox" name={name} checked={!!checked} onChange={onChange}
      style={{marginTop:'2px',accentColor:'var(--accent-color)'}} />
    <span>{label}</span>
  </label>
);

const btnStyle = (v='primary') => ({padding:'9px 20px',borderRadius:'5px',cursor:'pointer',fontSize:'13px',fontWeight:'600',
  border:v==='secondary'?'1px solid var(--border-color)':'none',
  background:v==='primary'?'var(--accent-color)':'var(--bg-secondary)',
  color:v==='secondary'?'var(--text-primary)':'#fff'});


// ── Component ────────────────────────────────────────────────
const Form8038 = () => {
  const [fd, setFd] = useState({
    bond_type: '', bond_type_amount: '', bond_type_desc: '',
    issuer_name:'', issuer_ein:'', street_address:'', city_state_zip:'',
    officer_name:'', officer_phone:'', other_contact_name:'', other_contact_phone:'',
    date_of_issue:'', name_of_issue:'', cusip:'', amended_return:false,
    final_maturity_date:'', issue_price:'', par_amount:'', wam:'', yield_rate:'',
    accrued_interest:'', issuance_costs:'', credit_enhancement:'', reserve_fund:'',
    has_refunding:false, refund_taxexempt:'', refund_taxable:'',
    land:'', buildings:'', equip_gt5:'', equip_le5:'', other_prop_desc:'', other_prop_amt:'',
    naics_count:1,
    naics_32a_sel:'', naics_32a_code:'', naics_32a_amt:'',
    naics_32b_sel:'', naics_32b_code:'', naics_32b_amt:'',
    naics_32c_sel:'', naics_32c_code:'', naics_32c_amt:'',
    naics_32d_sel:'', naics_32d_code:'', naics_32d_amt:'',
    refunded_wam_te:'', refunded_wam_taxable:'', last_call_date:'', refunded_issue_dates:'',
    tefra_gov_unit:'', tefra_approval_date:'', tefra_hearing_date:'', tefra_referendum_date:'',
    cb_bank_qualified:false, cb_penalty_rebate:false,
    cb_hedge:false, hedge_provider:'', hedge_type:'', hedge_term:'', cb_superintegrated:false,
    gic_amount:'', gic_maturity_date:'', gic_provider:'',
    cb_remediation:true, cb_sec148_monitor:true,
    reimbursement_amt:'', official_intent_date:'',
    cb_qualified_bonds:false, private_user_name:'', private_user_ein:'',
    cb_20_50:false, cb_40_60:false, cb_25_60:false, cb_deep_rent_yes:false, cb_deep_rent_no:true,
    cb_10m_exemption:false, cb_95_capex:false,
    vol_cap_allocated:'', vol_cap_subject:'',
    vol_cap_govt_owned:'', vol_cap_carryforward:'', vol_cap_trans_section:'', vol_cap_trans_amt:'',
    vol_cap_refunding:'', vol_cap_veterans:'', vol_cap_veterans_limit:'',
    vol_cap_ez:'', vol_cap_ez_name:'', vol_cap_broadband:'',
    signature_date:'', signer_name_title:'',
    ...PREPARER_DEFAULTS,
  });
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState('');
  const [confidence, setConfidence] = useState({});
  const [showOptionalPartI, setShowOptionalPartI] = useState(false);
  const [showVolCapDetails, setShowVolCapDetails] = useState(false);
  const [priorFile, setPriorFile] = useState(null);
  const [numbersFile, setNumbersFile] = useState(null);
  const [dragPrior, setDragPrior] = useState(false);
  const [dragNumbers, setDragNumbers] = useState(false);
  const priorRef = useRef();
  const numbersRef = useRef();

  const ch = e => {
    const {name,value,type,checked} = e.target;
    setFd(p => ({...p, [name]: type==='checkbox' ? checked : value}));
  };

  const bt = BOND_TYPES.find(b => b.value === fd.bond_type) || BOND_TYPES[0];
  const is142d = fd.bond_type === '142d_40_60' || fd.bond_type === '142d_20_50';
  const is501c3 = fd.bond_type === '501c3_capex' || fd.bond_type === '501c3_no_capex';
  const isHospital = fd.bond_type === 'hospital';
  const isSmallIssue = fd.bond_type === 'small_issue';
  const isReissuance = fd.bond_type === 'reissuance';
  const isOther = fd.bond_type === 'other';

  // Auto-calculate Part IV
  const pf = (v) => { const n = parseFloat(String(v||'').replace(/,/g,'')); return isNaN(n)?0:n; };
  const ip = pf(fd.issue_price);
  const usesTotal = pf(fd.issuance_costs) + pf(fd.credit_enhancement) + pf(fd.reserve_fund) + pf(fd.refund_taxexempt) + pf(fd.refund_taxable);
  const nonrefunding = ip - usesTotal;
  const fmt = v => v ? v.toLocaleString('en-US',{minimumFractionDigits:2,maximumFractionDigits:2}) : '0.00';

  // ── Upload handlers ────────────────────────────────────────
  const handlePriorFile = async (file) => {
    if (!file) return;
    setPriorFile(file);
    setBusy(true); setErr('');
    try {
      const form = new FormData(); form.append('file', file);
      const res = await fetch('/api/8038/extract-prior', {method:'POST', body:form});
      const data = await res.json();
      if (!res.ok) throw new Error(data.detail || 'Extraction failed');
      if (data.fields) setFd(p => ({...p, ...data.fields}));
    } catch(ex) { setErr(ex.message); }
    finally { setBusy(false); }
  };

  const handleNumbersFile = async (file) => {
    if (!file) return;
    setNumbersFile(file);
    setBusy(true); setErr('');
    try {
      const form = new FormData(); form.append('file', file);
      const res = await fetch('/api/8038/extract-numbers', {method:'POST', body:form});
      const data = await res.json();
      if (!res.ok) throw new Error(data.detail || 'Extraction failed');
      const m = {};
      Object.entries(data).forEach(([k,v]) => {
        if (k.startsWith('_') || k === 'source_notes') return;
        if (v !== null && v !== undefined && v !== '') m[k] = typeof v==='number' ? String(v) : v;
      });
      setFd(p => ({...p, ...m}));
      setConfidence(data._confidence || {});
    } catch(ex) { setErr(ex.message); }
    finally { setBusy(false); }
  };

  const onDrop = (handler, setDrag) => (e) => {
    e.preventDefault(); setDrag(false);
    const file = e.dataTransfer.files[0];
    if (file && file.type === 'application/pdf') handler(file);
    else setErr('Please drop a PDF file.');
  };

  // ── Generate ───────────────────────────────────────────────
  const doGenerate = async () => {
    if (!fd.bond_type) { setErr('Please select a bond type.'); return; }
    if (!fd.issuer_name) { setErr('Issuer name is required.'); return; }
    setErr(''); setBusy(true);
    try {
      const payload = {...fd};
      // Map bond type to line + checkboxes
      payload.bond_type_line = bt.line;
      payload.bond_type_amount = pf(fd.bond_type_amount) || null;
      // Housing checkboxes
      if (fd.bond_type === '142d_40_60') { payload.cb_40_60 = true; payload.cb_20_50 = false; }
      if (fd.bond_type === '142d_20_50') { payload.cb_20_50 = true; payload.cb_40_60 = false; }
      if (fd.bond_type === '501c3_capex') payload.cb_95_capex = true;
      // NAICS codes
      for (const s of ['32a','32b','32c','32d']) {
        const sel = fd[`naics_${s}_sel`];
        if (sel && sel !== 'other') payload[`naics_${s}_code`] = sel;
        else payload[`naics_${s}_code`] = fd[`naics_${s}_code`] || '';
        const a = pf(fd[`naics_${s}_amt`]); payload[`naics_${s}_amt`] = a || null;
      }
      // Numeric conversions
      for (const k of ['issue_price','par_amount','wam','yield_rate','accrued_interest','issuance_costs',
        'credit_enhancement','reserve_fund','refund_taxexempt','refund_taxable','refunded_wam_te',
        'refunded_wam_taxable','land','buildings','equip_gt5','equip_le5','other_prop_amt',
        'gic_amount','reimbursement_amt','vol_cap_allocated','vol_cap_subject','vol_cap_govt_owned',
        'vol_cap_carryforward','vol_cap_trans_amt','vol_cap_refunding','vol_cap_veterans',
        'vol_cap_veterans_limit','vol_cap_ez','vol_cap_broadband','bond_type_amount']) {
        const n = pf(payload[k]); payload[k] = n || null;
      }

      const res = await fetch('/api/8038/generate', {
        method:'POST', headers:{'Content-Type':'application/json'},
        body:JSON.stringify(payload)
      });
      if (!res.ok) { const d = await res.json().catch(()=>({})); throw new Error(d.detail||'Failed'); }
      const blob = await res.blob();
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a'); a.href = url;
      const iss = (fd.issuer_name||'issuer').replace(/[^a-zA-Z0-9]/g,'_').substring(0,30);
      a.download = `8038_${iss}.pdf`; a.click();
      URL.revokeObjectURL(url);
    } catch(ex) { setErr(ex.message); }
    finally { setBusy(false); }
  };

  return (
    <div style={cs}>
      <h2 style={{margin:'0 0 6px 0',fontSize:'20px',fontWeight:'700'}}>IRS Form 8038 Generator</h2>
      <p style={{margin:'0 0 24px 0',fontSize:'13px',color:'var(--text-secondary,#666)'}}>
        Information Return for Private Activity Bond Issues
      </p>

      {err && <div style={{color:'#c0392b',fontSize:'13px',marginBottom:'16px',padding:'10px',background:'#fdecea',borderRadius:'4px'}}>{err}</div>}

      {/* ── Section 1: Prior 8038 Upload ─────────────────── */}
      <div style={card}>
        <Hdr t="Upload Prior Form 8038 (optional — pre-fills issuer information)" />
        <div onClick={() => priorRef.current.click()}
          onDragOver={e => { e.preventDefault(); setDragPrior(true); }}
          onDragLeave={() => setDragPrior(false)}
          onDrop={onDrop(handlePriorFile, setDragPrior)}
          style={{border:`2px dashed ${priorFile ? 'var(--accent-color)' : dragPrior ? 'var(--accent-color)' : 'var(--border-color)'}`,
            borderRadius:'6px',padding:'22px',textAlign:'center',cursor:'pointer',
            background: priorFile ? 'var(--accent-subtle)' : dragPrior ? 'var(--accent-subtle)' : 'var(--bg-primary)'}}>
          <div style={{fontSize:'24px',marginBottom:'6px'}}>📋</div>
          {priorFile
            ? <div style={{color:'var(--accent-color)',fontWeight:'600'}}>{priorFile.name}</div>
            : <div style={{color:'var(--text-secondary,#666)',fontSize:'13px'}}>Click or drag a prior 8038 PDF here</div>}
        </div>
        <input ref={priorRef} type="file" accept=".pdf" style={{display:'none'}}
          onChange={e => { handlePriorFile(e.target.files[0]); e.target.value = ''; }} />
      </div>

      {/* ── Section 2: Numbers Packet Upload ─────────────── */}
      <div style={card}>
        <Hdr t="Upload Numbers Packet PDF (optional — pre-fills bond statistics)" />
        <div onClick={() => numbersRef.current.click()}
          onDragOver={e => { e.preventDefault(); setDragNumbers(true); }}
          onDragLeave={() => setDragNumbers(false)}
          onDrop={onDrop(handleNumbersFile, setDragNumbers)}
          style={{border:`2px dashed ${numbersFile ? 'var(--accent-color)' : dragNumbers ? 'var(--accent-color)' : 'var(--border-color)'}`,
            borderRadius:'6px',padding:'28px',textAlign:'center',cursor:'pointer',
            background: numbersFile ? 'var(--accent-subtle)' : dragNumbers ? 'var(--accent-subtle)' : 'var(--bg-primary)'}}>
          <div style={{fontSize:'28px',marginBottom:'8px'}}>📄</div>
          {numbersFile
            ? <div style={{color:'var(--accent-color)',fontWeight:'600'}}>{numbersFile.name}</div>
            : <div style={{color:'var(--text-secondary,#666)',fontSize:'13px'}}>Click or drag a numbers packet PDF here</div>}
        </div>
        <input ref={numbersRef} type="file" accept=".pdf" style={{display:'none'}}
          onChange={e => { handleNumbersFile(e.target.files[0]); e.target.value = ''; }} />
      </div>

      {/* ── Section 3: Bond Type ─────────────────────────── */}
      <div style={card}>
        <Hdr t="Bond Type Selection" />
        <div style={{marginBottom:'12px'}}>
          <label style={{display:'block',fontSize:'11px',fontWeight:'600',color:'var(--text-secondary)',marginBottom:'4px',textTransform:'uppercase',letterSpacing:'0.04em'}}>Type of Bond Issue</label>
          <select name="bond_type" value={fd.bond_type} onChange={ch}
            style={{width:'100%',padding:'8px 10px',border:'1px solid var(--border-color)',borderRadius:'4px',fontSize:'13px',background:'var(--bg-primary)',color:'var(--text-primary)'}}>
            {BOND_TYPES.map(b => <option key={b.value} value={b.value}>{b.label}</option>)}
          </select>
        </div>
        {fd.bond_type && (
          <F label="Issue Price ($)" name="bond_type_amount" value={fd.bond_type_amount} onChange={ch} placeholder="0.00" half />
        )}
        {(isReissuance || isOther) && (
          <F label="Description" name="bond_type_desc" value={fd.bond_type_desc} onChange={ch} placeholder="Describe the bond type" />
        )}
        {is142d && (
          <>
            <div style={{marginBottom:'10px'}}>
              <label style={{display:'block',fontSize:'11px',fontWeight:'600',color:'var(--text-secondary)',marginBottom:'4px',textTransform:'uppercase'}}>Deep Rent Skewing Election</label>
              <div style={{display:'flex',gap:'16px'}}>
                <label style={{display:'flex',alignItems:'center',gap:'5px',fontSize:'13px',cursor:'pointer'}}>
                  <input type="radio" name="deep_rent" checked={fd.cb_deep_rent_yes} onChange={()=>setFd(p=>({...p,cb_deep_rent_yes:true,cb_deep_rent_no:false}))} /> Yes
                </label>
                <label style={{display:'flex',alignItems:'center',gap:'5px',fontSize:'13px',cursor:'pointer'}}>
                  <input type="radio" name="deep_rent" checked={fd.cb_deep_rent_no} onChange={()=>setFd(p=>({...p,cb_deep_rent_yes:false,cb_deep_rent_no:true}))} /> No
                </label>
              </div>
            </div>
            <Chk label="NYC 25-60 test" name="cb_25_60" checked={fd.cb_25_60} onChange={ch} />
          </>
        )}
        {isSmallIssue && (
          <Chk label="$10 million small issue exemption elected" name="cb_10m_exemption" checked={fd.cb_10m_exemption} onChange={ch} />
        )}
        {(bt.showLine46 || is142d) && (
          <div style={{marginTop:'12px',paddingTop:'12px',borderTop:'1px solid var(--border-color)'}}>
            <div style={{fontSize:'12px',fontWeight:'600',color:'var(--text-secondary)',marginBottom:'8px',textTransform:'uppercase'}}>Line 46 — Primary Private User</div>
            <div style={sRow}>
              <F label="Name" name="private_user_name" value={fd.private_user_name} onChange={ch} half />
              <F label="EIN" name="private_user_ein" value={fd.private_user_ein} onChange={ch} placeholder="XX-XXXXXXX" half />
            </div>
            <Chk label="Qualified redevelopment, small issue, or exempt facilities bonds" name="cb_qualified_bonds" checked={fd.cb_qualified_bonds} onChange={ch} />
          </div>
        )}
      </div>

      {/* ── Section 4: Part I ────────────────────────────── */}
      <div style={card}>
        <Hdr t="Part I — Issuer Information" />
        <F label="Line 1: Issuer's Name" name="issuer_name" value={fd.issuer_name} onChange={ch} />
        <div style={sRow}>
          <F label="Line 2: Issuer's EIN" name="issuer_ein" value={fd.issuer_ein} onChange={ch} placeholder="XX-XXXXXXX" half />
          <F label="Line 9: CUSIP" name="cusip" value={fd.cusip} onChange={ch} placeholder="9-character CUSIP" half />
        </div>
        <F label="Line 4: Street Address" name="street_address" value={fd.street_address} onChange={ch} />
        <F label="Line 6: City, State, ZIP" name="city_state_zip" value={fd.city_state_zip} onChange={ch} />
        <div style={sRow}>
          <F label="Line 7: Date of Issue" name="date_of_issue" value={fd.date_of_issue} warn={confidence.date_of_issue||''} onChange={ch} placeholder="MM/DD/YYYY" half />
          <F label="Line 8: Name of Issue" name="name_of_issue" value={fd.name_of_issue} warn={confidence.name_of_issue||''} onChange={ch} half />
        </div>
        <div style={sRow}>
          <F label="Line 10a: Officer Name & Title" name="officer_name" value={fd.officer_name} onChange={ch} half />
          <F label="Line 10b: Officer Phone" name="officer_phone" value={fd.officer_phone} onChange={ch} placeholder="(XXX) XXX-XXXX" half />
        </div>
        <button onClick={()=>setShowOptionalPartI(!showOptionalPartI)} style={{...btnStyle('secondary'),fontSize:'12px',padding:'5px 12px',marginTop:'4px'}}>
          {showOptionalPartI ? 'Hide' : 'Show'} Optional Fields
        </button>
        {showOptionalPartI && (
          <div style={{marginTop:'12px'}}>
            <div style={sRow}>
              <F label="Line 3a: Other IRS Contact Name" name="other_contact_name" value={fd.other_contact_name} onChange={ch} half />
              <F label="Line 3b: Other Contact Phone" name="other_contact_phone" value={fd.other_contact_phone} onChange={ch} half />
            </div>
            <Chk label="Amended Return" name="amended_return" checked={fd.amended_return} onChange={ch} />
          </div>
        )}
      </div>

      {/* ── Section 5: Part III ───────────────────────────── */}
      <div style={card}>
        <Hdr t="Part III — Description of Bonds (Line 21)" />
        <div style={sRow}>
          <F label="21(a): Final Maturity Date" name="final_maturity_date" value={fd.final_maturity_date} warn={confidence.final_maturity_date||''} onChange={ch} placeholder="MM/DD/YYYY" half />
          <F label="21(b): Issue Price ($)" name="issue_price" value={fd.issue_price} warn={confidence.issue_price||''} onChange={ch} placeholder="0.00" half />
        </div>
        <div style={sRow}>
          <F label="21(c): Total Par ($)" name="par_amount" value={fd.par_amount} warn={confidence.par_amount||''} onChange={ch} placeholder="0.00" half />
          <F label="21(d): WAM (years)" name="wam" value={fd.wam} warn={confidence.wam||''} onChange={ch} placeholder="0.000" half />
        </div>
        <F label="21(e): Arbitrage Yield per §1.148-4" name="yield_rate" value={fd.yield_rate} warn={confidence.yield_rate||''} onChange={ch} placeholder="0.0000" half />
      </div>

      {/* ── Section 6: Part IV ───────────────────────────── */}
      <div style={card}>
        <Hdr t="Part IV — Uses of Proceeds" />
        <div style={sRow}>
          <F label="Line 22: Accrued Interest ($)" name="accrued_interest" value={fd.accrued_interest} warn={confidence.accrued_interest||''} onChange={ch} placeholder="0.00" half />
          <F label="Line 23: Issue Price ($)" name="_ip23" value={ip ? fmt(ip) : ''} onChange={()=>{}} ro half />
        </div>
        <div style={sRow}>
          <F label="Line 24: Issuance Costs ($)" name="issuance_costs" value={fd.issuance_costs} warn={confidence.issuance_costs||''} onChange={ch} placeholder="0.00" half />
          <F label="Line 25: Credit Enhancement ($)" name="credit_enhancement" value={fd.credit_enhancement} onChange={ch} placeholder="0.00" half />
        </div>
        <F label="Line 26: Reserve/Replacement Fund ($)" name="reserve_fund" value={fd.reserve_fund} onChange={ch} placeholder="0.00" half />
        <Chk label="This is a refunding issue" name="has_refunding" checked={fd.has_refunding} onChange={ch} />
        {fd.has_refunding && (
          <div style={{paddingLeft:'24px'}}>
            <div style={sRow}>
              <F label="Line 27: Refund Tax-Exempt ($)" name="refund_taxexempt" value={fd.refund_taxexempt} warn={confidence.refund_taxexempt||''} onChange={ch} placeholder="0.00" half />
              <F label="Line 28: Refund Taxable ($)" name="refund_taxable" value={fd.refund_taxable} onChange={ch} placeholder="0.00" half />
            </div>
          </div>
        )}
        <div style={sRow}>
          <F label="Line 29: Total Uses ($)" name="_uses" value={usesTotal ? fmt(usesTotal) : '0.00'} onChange={()=>{}} ro half />
          <F label="Line 30: Nonrefunding Proceeds ($)" name="_nr" value={fmt(nonrefunding)} onChange={()=>{}} ro half />
        </div>
      </div>

      {/* ── Section 7: Part V ────────────────────────────── */}
      {bt.showPartV && (
        <div style={card}>
          <Hdr t="Part V — Description of Property Financed" />
          <div style={sRow}>
            <F label="31a: Land ($)" name="land" value={fd.land} onChange={ch} placeholder="0" half />
            <F label="31b: Buildings & Structures ($)" name="buildings" value={fd.buildings} onChange={ch} placeholder="0" half />
          </div>
          <div style={sRow}>
            <F label="31c: Equipment >5yr recovery ($)" name="equip_gt5" value={fd.equip_gt5} onChange={ch} placeholder="0" half />
            <F label="31d: Equipment ≤5yr recovery ($)" name="equip_le5" value={fd.equip_le5} onChange={ch} placeholder="0" half />
          </div>
          <div style={sRow}>
            <F label="31e: Other — Description" name="other_prop_desc" value={fd.other_prop_desc} onChange={ch} half />
            <F label="31e: Other — Amount ($)" name="other_prop_amt" value={fd.other_prop_amt} onChange={ch} placeholder="0" half />
          </div>
          <div style={{marginTop:'8px',fontSize:'12px',fontWeight:'600',color:'var(--text-secondary)',marginBottom:'8px',textTransform:'uppercase'}}>NAICS Codes (Lines 32a-32d)</div>
          {['32a','32b','32c','32d'].slice(0, fd.naics_count).map(s => (
            <div key={s} style={{...sRow, marginBottom:'8px'}}>
              <div style={{flex:'1 1 50%'}}>
                <select name={`naics_${s}_sel`} value={fd[`naics_${s}_sel`]} onChange={ch}
                  style={{width:'100%',padding:'7px 10px',border:'1px solid var(--border-color)',borderRadius:'4px',fontSize:'12px',background:'var(--bg-primary)',color:'var(--text-primary)'}}>
                  {NAICS_OPTIONS.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
                </select>
                {fd[`naics_${s}_sel`] === 'other' && (
                  <input type="text" name={`naics_${s}_code`} value={fd[`naics_${s}_code`]||''} onChange={ch}
                    placeholder="6-digit NAICS code" style={{width:'100%',padding:'5px 8px',marginTop:'4px',border:'1px solid var(--border-color)',borderRadius:'4px',fontSize:'12px',background:'var(--bg-primary)',color:'var(--text-primary)',boxSizing:'border-box'}} />
                )}
              </div>
              <F label={`${s} Amount ($)`} name={`naics_${s}_amt`} value={fd[`naics_${s}_amt`]} onChange={ch} placeholder="0" half />
            </div>
          ))}
          {fd.naics_count < 4 && (
            <button onClick={()=>setFd(p=>({...p,naics_count:p.naics_count+1}))} style={{...btnStyle('secondary'),fontSize:'12px',padding:'5px 12px'}}>
              + Add another project
            </button>
          )}
        </div>
      )}

      {/* ── Section 8: Part VI ───────────────────────────── */}
      {fd.has_refunding && (
        <div style={card}>
          <Hdr t="Part VI — Description of Refunded Bonds" />
          <div style={sRow}>
            <F label="Line 33: Remaining WAM of Refunded TE Bonds (years)" name="refunded_wam_te" value={fd.refunded_wam_te} warn={confidence.refunded_wam_te||''} onChange={ch} half />
            <F label="Line 34: Remaining WAM of Refunded Taxable (years)" name="refunded_wam_taxable" value={fd.refunded_wam_taxable} onChange={ch} half />
          </div>
          <div style={sRow}>
            <F label="Line 35: Last Call Date of Refunded TE Bonds" name="last_call_date" value={fd.last_call_date} warn={confidence.last_call_date||''} onChange={ch} placeholder="MM/DD/YYYY" half />
            <F label="Line 36: Date(s) Refunded Bonds Were Issued" name="refunded_issue_dates" value={fd.refunded_issue_dates} warn={confidence.refunded_issue_dates||''} onChange={ch} placeholder="MM/DD/YYYY" half />
          </div>
        </div>
      )}

      {/* ── Section 9: Part VII ──────────────────────────── */}
      <div style={card}>
        <Hdr t="Part VII — Miscellaneous" />
        <F label="Line 37: TEFRA — Governmental Unit(s) Approving Issue" name="tefra_gov_unit" value={fd.tefra_gov_unit} onChange={ch} />
        <div style={sRow}>
          <F label="Date of Approval" name="tefra_approval_date" value={fd.tefra_approval_date} onChange={ch} placeholder="MM/DD/YYYY" half />
          <F label="Date of Public Hearing" name="tefra_hearing_date" value={fd.tefra_hearing_date} onChange={ch} placeholder="MM/DD/YYYY" half />
        </div>
        <F label="Date of Voter Referendum (optional)" name="tefra_referendum_date" value={fd.tefra_referendum_date} onChange={ch} placeholder="MM/DD/YYYY" half />
        <Chk label="Line 38: Designated as bank-qualified under §265(b)(3)(B)(i)(III)" name="cb_bank_qualified" checked={fd.cb_bank_qualified} onChange={ch} />
        <Chk label="Line 39: Elected to pay penalty in lieu of arbitrage rebate (§148(f)(4)(C))" name="cb_penalty_rebate" checked={fd.cb_penalty_rebate} onChange={ch} />
        <Chk label="Line 40a: Identified a hedge" name="cb_hedge" checked={fd.cb_hedge} onChange={ch} />
        {fd.cb_hedge && (
          <div style={{paddingLeft:'24px'}}>
            <F label="40b: Hedge Provider" name="hedge_provider" value={fd.hedge_provider} onChange={ch} />
            <div style={sRow}>
              <F label="40c: Type of Hedge" name="hedge_type" value={fd.hedge_type} onChange={ch} placeholder="e.g. Interest rate swap" half />
              <F label="40d: Term of Hedge" name="hedge_term" value={fd.hedge_term} onChange={ch} placeholder="e.g. 10 years" half />
            </div>
            <Chk label="Line 41: Superintegrated hedge" name="cb_superintegrated" checked={fd.cb_superintegrated} onChange={ch} />
          </div>
        )}
        <F label="Line 42a: GIC Amount ($)" name="gic_amount" value={fd.gic_amount} onChange={ch} placeholder="0" half />
        {fd.gic_amount && String(fd.gic_amount).replace(/[,$\s]/g,'') !== '' && String(fd.gic_amount).replace(/[,$\s]/g,'') !== '0' && (
          <div style={{paddingLeft:'24px'}}>
            <F label="Line 42b: Final maturity date of GIC (MM/DD/YYYY)" name="gic_maturity_date" value={fd.gic_maturity_date} onChange={ch} placeholder="MM/DD/YYYY" half />
            <F label="Line 42c: Name of GIC provider" name="gic_provider" value={fd.gic_provider} onChange={ch} />
          </div>
        )}
        <Chk label="Line 43: Written procedures for remediation of nonqualified bonds" name="cb_remediation" checked={fd.cb_remediation} onChange={ch} />
        <Chk label="Line 44: Written procedures to monitor §148 arbitrage requirements" name="cb_sec148_monitor" checked={fd.cb_sec148_monitor} onChange={ch} />
        <F label="Line 45a: Reimbursement Proceeds ($)" name="reimbursement_amt" value={fd.reimbursement_amt} onChange={ch} placeholder="0" half />
        {fd.reimbursement_amt && String(fd.reimbursement_amt).replace(/[,$\s]/g,'') !== '' && String(fd.reimbursement_amt).replace(/[,$\s]/g,'') !== '0' && (
          <div style={{paddingLeft:'24px'}}>
            <F label="Line 45b: Date official intent was adopted (MM/DD/YYYY)" name="official_intent_date" value={fd.official_intent_date} onChange={ch} placeholder="MM/DD/YYYY" half />
          </div>
        )}
        {/* Line 46 shown here only if NOT already shown in Bond Type section */}
        {!bt.showLine46 && !is142d && (
          <>
            <Chk label="Line 46: Qualified redevelopment, small issue, or exempt facilities bonds" name="cb_qualified_bonds" checked={fd.cb_qualified_bonds} onChange={ch} />
            {fd.cb_qualified_bonds && (
              <div style={{paddingLeft:'24px'}}>
                <div style={sRow}>
                  <F label="Primary Private User Name" name="private_user_name" value={fd.private_user_name} onChange={ch} half />
                  <F label="Primary Private User EIN" name="private_user_ein" value={fd.private_user_ein} onChange={ch} placeholder="XX-XXXXXXX" half />
                </div>
              </div>
            )}
          </>
        )}
      </div>

      {/* ── Section 10: Part VIII ─────────────────────────── */}
      {bt.showVolCap && (
        <div style={card}>
          <Hdr t="Part VIII — Volume Caps" />
          <div style={sRow}>
            <F label="Line 47: Amount of state volume cap allocated to the issuer. Attach copy of state certification. ($)" name="vol_cap_allocated" value={fd.vol_cap_allocated} onChange={ch} placeholder="0.00" />
            <F label="Line 48: Amount of issue subject to the unified state volume cap ($)" name="vol_cap_subject" value={fd.vol_cap_subject} onChange={ch} placeholder="0.00" />
          </div>
          <button onClick={()=>setShowVolCapDetails(!showVolCapDetails)} style={{...btnStyle('secondary'),fontSize:'12px',padding:'5px 12px',marginTop:'4px'}}>
            {showVolCapDetails ? 'Hide' : 'Show'} Additional Volume Cap Details
          </button>
          {showVolCapDetails && (
            <div style={{marginTop:'12px'}}>
              <div style={sRow}>
                <F label="49a: Governmentally Owned ($)" name="vol_cap_govt_owned" value={fd.vol_cap_govt_owned} onChange={ch} placeholder="0" half />
                <F label="49b: Carryforward ($)" name="vol_cap_carryforward" value={fd.vol_cap_carryforward} onChange={ch} placeholder="0" half />
              </div>
              <div style={sRow}>
                <F label="49c: Transitional Rule Section" name="vol_cap_trans_section" value={fd.vol_cap_trans_section} onChange={ch} half />
                <F label="49c: Amount ($)" name="vol_cap_trans_amt" value={fd.vol_cap_trans_amt} onChange={ch} placeholder="0" half />
              </div>
              <F label="49d: Current Refunding Exception ($)" name="vol_cap_refunding" value={fd.vol_cap_refunding} onChange={ch} placeholder="0" half />
            </div>
          )}
        </div>
      )}

      {/* ── Section 11: Paid Preparer ────────────────────── */}
      <div style={card}>
        <Hdr t="Signature & Paid Preparer" />
        <div style={sRow}>
          <F label="Signature Date" name="signature_date" value={fd.signature_date} onChange={ch} placeholder="MM/DD/YYYY" half />
          <F label="Signer Name & Title" name="signer_name_title" value={fd.signer_name_title} onChange={ch} half />
        </div>
        <div style={{marginTop:'8px',fontSize:'12px',fontWeight:'600',color:'var(--text-secondary)',marginBottom:'8px',textTransform:'uppercase'}}>Paid Preparer (pre-filled)</div>
        <div style={sRow}>
          <F label="Preparer Name" name="preparer_name" value={fd.preparer_name} onChange={ch} half />
          <F label="PTIN" name="preparer_ptin" value={fd.preparer_ptin} onChange={ch} half />
        </div>
        <div style={sRow}>
          <F label="Firm Name" name="firm_name" value={fd.firm_name} onChange={ch} half />
          <F label="Firm EIN" name="firm_ein" value={fd.firm_ein} onChange={ch} half />
        </div>
        <F label="Firm Address" name="firm_address" value={fd.firm_address} onChange={ch} />
        <F label="Phone" name="firm_phone" value={fd.firm_phone} onChange={ch} half />
      </div>

      {/* ── Generate Button ──────────────────────────────── */}
      <div style={{display:'flex',gap:'12px',paddingBottom:'32px'}}>
        <button style={{...btnStyle(),opacity:busy?0.7:1}} onClick={doGenerate} disabled={busy}>
          {busy ? '⏳ Generating PDF…' : '📄 Generate Form 8038 PDF'}
        </button>
      </div>
    </div>
  );
};

export default Form8038;
